import { createInstance as api } from './index'

export default {
    customerOrder(params) {
        const url = '/customerorder/order' + (params.id ? `/${params.id}` : '');
        const method = params.method.toLowerCase();
        const config = ['get', 'delete'].includes(method)
            ? { params: params.query }
            : params;

        return api(URL)[method](url, config);
    }
}